var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceBox6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 300,
    viewBox: "0 0 389 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_11418)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 300,
    rx: 4,
    fill: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.5205 -105C-18.4341 -90.7928 24.2448 -50.5925 80.4933 -60.3341C111.27 -65.6711 155.451 -50.3865 169.854 -14.6701C169.854 -14.6701 184.292 55.7993 259.533 41.0767C291.031 34.9149 322.148 51.8294 344.476 80.84C354.302 93.5975 372.494 115.962 370.059 130.494C369.009 136.771 363.713 140.602 359.565 144.943C348.014 157.08 342.395 177.918 353.142 197.234C363.024 214.979 387.951 221.197 400.521 236.864C459.658 310.563 371.426 331.265 350.689 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-372.521 -105C-359.434 -90.7928 -316.755 -50.5925 -260.507 -60.3341C-229.73 -65.6711 -185.549 -50.3865 -171.146 -14.6701C-171.146 -14.6701 -156.708 55.7993 -81.4665 41.0767C-49.9692 34.9149 -18.8518 51.8294 3.47638 80.84C13.3021 93.5975 31.4937 115.962 29.0595 130.494C28.0085 136.771 22.7129 140.602 18.5649 144.943C7.01365 157.08 1.3947 177.918 12.1423 197.234C22.0242 214.979 46.9514 221.197 59.5208 236.864C118.658 310.563 30.4258 331.265 9.68887 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1039_11418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.273 76.6382H122.779C116.957 76.6382 112.23 71.9148 112.23 66.0974V51.032C112.23 45.2147 116.957 40.4912 122.779 40.4912H154.273C160.095 40.4912 164.821 45.2147 164.821 51.032V66.1472C164.821 71.9645 160.095 76.6382 154.273 76.6382Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.421 56.6016H125.217V57.7949H134.421V56.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.164 53.4189H125.217V54.6122H146.164V53.4189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.747 129.74H221.492C217.959 129.74 215.073 126.856 215.073 123.326V114.078C215.073 110.548 217.959 107.664 221.492 107.664H240.747C244.279 107.664 247.165 110.548 247.165 114.078V123.326C247.165 126.856 244.279 129.74 240.747 129.74Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06 121H241.683V120.254H236.06V121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.882 122.964H241.669V122.218H228.882V122.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.231 79.3731H243.285C241.991 79.3731 240.996 78.329 240.996 77.086C240.996 75.7932 242.041 74.7988 243.285 74.7988H254.231C255.525 74.7988 256.52 75.843 256.52 77.086C256.52 78.3787 255.475 79.3731 254.231 79.3731Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.921 83.9727H247.961V81.9341H245.921V83.9727Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.666 83.9727H244.706V81.9341H242.666V83.9727Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.666 86.9883H244.706V84.9497H242.666V86.9883Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.355 88.7206V86.2345C320.355 80.8647 315.977 76.4893 310.603 76.4893H257.415",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 145.502H276.521V92.9969C276.521 90.7097 278.362 88.8203 280.701 88.8203H357.871C360.16 88.8203 362.05 90.66 362.05 92.9969V145.502H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.521 95.4824H362",
    stroke: "#F5C679",
    strokeWidth: 0.8925,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.692 94.0408C283.681 94.0408 284.483 93.2394 284.483 92.2509C284.483 91.2623 283.681 90.4609 282.692 90.4609C281.702 90.4609 280.9 91.2623 280.9 92.2509C280.9 93.2394 281.702 94.0408 282.692 94.0408Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.209 94.0408C290.198 94.0408 291 93.2394 291 92.2509C291 91.2623 290.198 90.4609 289.209 90.4609C288.22 90.4609 287.418 91.2623 287.418 92.2509C287.418 93.2394 288.22 94.0408 289.209 94.0408Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.727 94.0408C296.716 94.0408 297.518 93.2394 297.518 92.2509C297.518 91.2623 296.716 90.4609 295.727 90.4609C294.737 90.4609 293.936 91.2623 293.936 92.2509C293.936 93.2394 294.737 94.0408 295.727 94.0408Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.966 119.647C298.066 114.427 302.344 110.25 307.569 110.25V101.648C297.518 101.648 289.408 109.753 289.408 119.797C289.408 119.598 293.588 119.598 297.966 119.647Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.171 119.847C317.171 125.167 312.892 129.443 307.568 129.443V137.995C317.619 137.995 325.729 129.89 325.729 119.847H317.171Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.966 119.846C297.966 119.796 297.966 119.697 297.966 119.647C293.588 119.597 289.408 119.597 289.408 119.846C289.408 129.89 297.518 137.994 307.569 137.994V129.442C302.245 129.392 297.966 125.116 297.966 119.846Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.171 119.846H325.729C325.729 109.803 317.619 101.698 307.568 101.698V110.25C312.842 110.25 317.171 114.526 317.171 119.846Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.569 114.178C304.484 114.178 301.996 116.614 301.946 119.697C304.683 119.746 307.569 119.796 307.569 119.796V114.178Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.568 125.464C310.653 125.464 313.191 122.928 313.191 119.846H307.568V125.464Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.946 119.696C301.946 119.746 301.946 119.746 301.946 119.796C301.946 122.878 304.484 125.414 307.569 125.414V119.796C307.569 119.845 304.683 119.746 301.946 119.696Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.568 114.178V119.796H313.191C313.191 116.713 310.653 114.178 307.568 114.178Z",
    fill: "#D4603F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.088 107.664H335.879V108.758H344.088V107.664Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.587 110.548H335.879V111.642H354.587V110.548Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.567 103.736H332.794V117.111H358.567V103.736Z",
    stroke: "#F5C679",
    strokeWidth: 0.8925,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.916 131.083H340.706V132.177H348.916V131.083Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.218 131.779C338.218 130.735 337.372 129.89 336.327 129.89C335.282 129.89 334.437 130.735 334.437 131.779C334.437 132.823 335.282 133.668 336.327 133.668C337.372 133.619 338.218 132.823 338.218 131.779Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.479 199.051H27V146.546C27 144.259 28.8409 142.369 31.1794 142.369H108.349C110.638 142.369 112.529 144.209 112.529 146.546V199.051H112.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 149.031H112.479",
    stroke: "#F5C679",
    strokeWidth: 0.8925,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9613 145.8C34.9613 144.805 34.1652 144.01 33.1701 144.01C32.175 144.01 31.3789 144.805 31.3789 145.8C31.3789 146.794 32.175 147.59 33.1701 147.59C34.1652 147.59 34.9613 146.794 34.9613 145.8Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4788 145.8C41.4788 144.805 40.6828 144.01 39.6877 144.01C38.6926 144.01 37.8965 144.805 37.8965 145.8C37.8965 146.794 38.6926 147.59 39.6877 147.59C40.6828 147.59 41.4788 146.794 41.4788 145.8Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9466 145.8C47.9466 144.805 47.1505 144.01 46.1554 144.01C45.1603 144.01 44.3643 144.805 44.3643 145.8C44.3643 146.794 45.1603 147.59 46.1554 147.59C47.1505 147.59 47.9466 146.794 47.9466 145.8Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0471 159.921C50.6833 159.921 44.7127 165.788 44.5635 173.147C51.1809 173.246 58.0471 173.395 58.0471 173.395V159.921Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0469 186.87C65.5101 186.87 71.5305 180.854 71.5305 173.396H58.0469V186.87Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5635 173.146C44.5635 173.246 44.5635 173.345 44.5635 173.395C44.5635 180.853 50.5838 186.869 58.0471 186.869V173.395C58.0471 173.395 51.1809 173.196 44.5635 173.146Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0469 159.921V173.395H71.5305C71.5305 165.937 65.5101 159.921 58.0469 159.921Z",
    fill: "#D4603F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.567 161.263H86.3574V162.357H94.567V161.263Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.065 164.097H86.3574V165.191H105.065V164.097Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.095 157.285H83.3223V170.66H109.095V157.285Z",
    stroke: "#F5C679",
    strokeWidth: 0.8925,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3941 184.682H91.1846V185.776H99.3941V184.682Z",
    fill: "#FFB264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7462 185.328C88.7462 184.284 87.9004 183.438 86.8555 183.438C85.8107 183.438 84.9648 184.284 84.9648 185.328C84.9648 186.372 85.8107 187.217 86.8555 187.217C87.9004 187.217 88.7462 186.372 88.7462 185.328Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7152 79.0752H62.9233C57.7487 79.0752 53.5693 83.2517 53.5693 88.4227V143.066",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0531 81.4112H87.9992C89.2928 81.4112 90.2879 80.3671 90.2879 79.1241C90.2879 77.8313 89.2431 76.8369 87.9992 76.8369H77.0531C75.7595 76.8369 74.7644 77.8811 74.7644 79.1241C74.7146 80.3671 75.7595 81.4112 77.0531 81.4112Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3124 83.9473H83.2725V85.9858H85.3124V83.9473Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5966 83.9473H86.5566V85.9858H88.5966V83.9473Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5966 86.9805H86.5566V89.019H88.5966V86.9805Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.197 130.638C220.018 127.02 234.773 106.408 231.152 84.6014C227.531 62.7944 206.905 48.0499 185.083 51.6686C163.261 55.2872 148.507 75.8987 152.128 97.7056C155.749 119.513 176.375 134.257 198.197 130.638Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.692 91.1571C231.692 69.0811 213.781 51.1318 191.64 51.1318C169.548 51.1318 151.587 69.0313 151.587 91.1571",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.993 91.1571H151.637C151.637 69.0811 169.548 51.1318 191.689 51.1318L190.993 91.1571Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.945 123.448C241.782 105.623 241.782 76.723 223.945 58.8982C206.108 41.0734 177.189 41.0734 159.352 58.8982C141.514 76.723 141.514 105.623 159.352 123.448C177.189 141.272 206.108 141.272 223.945 123.448Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.979 70.9207L219.204 55.7559H281.049",
    stroke: "#1B314F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.048 57.745C282.34 57.745 283.387 56.6988 283.387 55.4082C283.387 54.1175 282.34 53.0713 281.048 53.0713C279.757 53.0713 278.71 54.1175 278.71 55.4082C278.71 56.6988 279.757 57.745 281.048 57.745Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4 124.569L204.625 139.784H266.521",
    stroke: "#1B314F",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.52 142.419C267.812 142.419 268.859 141.373 268.859 140.082C268.859 138.791 267.812 137.745 266.52 137.745C265.229 137.745 264.182 138.791 264.182 140.082C264.182 141.373 265.229 142.419 266.52 142.419Z",
    fill: "#1B314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.888 136.751H213.482C212.188 136.751 211.144 135.707 211.144 134.414C211.144 133.121 212.188 132.077 213.482 132.077H252.888C254.182 132.077 255.226 133.121 255.226 134.414C255.276 135.707 254.182 136.751 252.888 136.751Z",
    fill: "#D4603F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.504 48.7949H220.497C219.552 48.7949 218.756 47.9994 218.756 47.0547C218.756 46.11 219.552 45.3145 220.497 45.3145H249.504C250.45 45.3145 251.246 46.11 251.246 47.0547C251.246 48.0491 250.45 48.7949 249.504 48.7949Z",
    fill: "#D4603F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.195 41.5358H220C219.303 41.5358 218.756 40.9889 218.756 40.2928C218.756 39.5967 219.303 39.0498 220 39.0498H241.195C241.892 39.0498 242.439 39.5967 242.439 40.2928C242.439 40.9392 241.892 41.5358 241.195 41.5358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.764 210.686H171.985V151.866C171.985 149.281 174.075 147.192 176.662 147.192H263.136C265.724 147.192 267.813 149.281 267.813 151.866V210.686H267.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.985 154.65H267.764",
    stroke: "#F5C679",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.951 153.01C180.05 153.01 180.941 152.119 180.941 151.021C180.941 149.923 180.05 149.032 178.951 149.032C177.852 149.032 176.961 149.923 176.961 151.021C176.961 152.119 177.852 153.01 178.951 153.01Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.215 153.01C187.314 153.01 188.205 152.119 188.205 151.021C188.205 149.923 187.314 149.032 186.215 149.032C185.116 149.032 184.225 149.923 184.225 151.021C184.225 152.119 185.116 153.01 186.215 153.01Z",
    fill: "#E37059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.479 153.01C194.579 153.01 195.47 152.119 195.47 151.021C195.47 149.923 194.579 149.032 193.479 149.032C192.38 149.032 191.489 149.923 191.489 151.021C191.489 152.119 192.38 153.01 193.479 153.01Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 166.882V202.929H259.654",
    stroke: "#F5C679",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.877 190.699C183.877 190.699 188.753 174.589 196.465 174.838C206.416 175.186 205.719 192.041 211.69 191.395C222.536 190.201 219.651 164.943 231.194 167.578C236.319 168.772 234.527 191.743 239.453 195.372C242.538 197.659 249.305 188.909 252.34 187.119C255.375 185.329 258.609 186.124 258.609 186.124L258.957 202.681L183.827 203.029V190.699H183.877Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.209 164.893H239.155C240.448 164.893 241.443 163.849 241.443 162.606C241.443 161.313 240.399 160.318 239.155 160.318H228.209C226.915 160.318 225.92 161.362 225.92 162.606C225.92 163.849 226.915 164.893 228.209 164.893Z",
    fill: "#4475AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.517 167.429H234.478V169.467H236.517V167.429Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.752 167.429H237.712V169.467H239.752V167.429Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.752 170.462H237.712V172.5H239.752V170.462Z",
    fill: "#F5C679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.535 137.795V210.885C141.535 219.088 148.202 225.751 156.412 225.751H200.744C208.953 225.751 215.62 219.088 215.62 210.885",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.536 175.434C143.899 175.434 145.815 173.519 145.815 171.158C145.815 168.796 143.899 166.882 141.536 166.882C139.173 166.882 137.257 168.796 137.257 171.158C137.257 173.519 139.173 175.434 141.536 175.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.536 178.516C145.602 178.516 148.899 175.222 148.899 171.158C148.899 167.093 145.602 163.799 141.536 163.799C137.469 163.799 134.172 167.093 134.172 171.158C134.172 175.222 137.469 178.516 141.536 178.516Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.545 132.425H110.141V134.712H129.545V132.425Z",
    fill: "#000307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.141 132.425H122.828L121.833 134.662H110.141V132.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.826 134.663H123.227L130.59 113.581H161.19L153.826 134.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.023 124.718C144.023 123.674 143.178 122.779 142.083 122.779C141.038 122.779 140.143 123.625 140.143 124.718C140.143 125.763 140.988 126.658 142.083 126.658C143.128 126.658 144.023 125.812 144.023 124.718Z",
    fill: "#000307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.782 134.663H104.816V137.696H172.782V134.663Z",
    fill: "#4475AB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.293 286.844H277.604C278.727 285.467 278.314 280.389 278.146 278.74C278.108 278.403 278.082 278.208 278.082 278.208C278.082 278.208 270.126 271.806 269.029 276.714C268.99 276.87 268.951 277.013 268.912 277.169C267.53 281.753 261.357 283.831 257.793 284.415C255.468 284.779 254.616 285.999 254.293 286.844Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.885 210.692C317.045 210.692 277.966 218.069 271.496 226.12C268.267 230.146 267.789 276.558 267.789 276.558C267.789 276.558 271.78 281.545 280.407 278.649C280.407 278.649 286.735 246.885 286.27 237.262C286.141 234.6 312.964 236.873 317.885 235.6C322.805 234.327 334.79 223.575 332.155 218.341C329.508 213.108 317.885 210.692 317.885 210.692Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.676 199.329C271.676 199.329 263.798 199.433 261.925 200.238C260.065 201.043 256.281 202.887 257.289 203.173C258.296 203.459 263.126 203.056 264.172 203.212C265.218 203.368 266.497 203.173 267.143 203.173C267.775 203.173 270.759 203.173 270.759 203.173L271.676 199.329Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.455 180.305C262.455 180.305 259.768 178.37 257.16 177.993C255.675 177.785 254.228 177.513 253.35 177.201C250.948 176.344 246.118 171.994 246.492 171.474C247.655 169.838 253.285 173.305 254.267 172.929C255.248 172.552 252.381 170.5 253.376 169.786C253.892 169.409 255.119 171.292 256.114 171.487C257.457 171.747 258.516 173.656 258.916 173.76C259.704 173.955 263.165 176.539 263.165 176.539L262.455 180.305Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.998 157.761C313.998 157.761 307.992 159.631 302.09 176.006C296.175 192.382 293.928 193.265 291.785 193.901C289.641 194.538 270.772 198.317 270.772 198.317V203.174H299.843C299.843 203.174 310.743 192.746 314.011 185.733C317.265 178.707 313.998 157.761 313.998 157.761Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 286.844H267.311C268.434 285.467 268.021 280.389 267.853 278.74C267.815 278.403 267.789 278.208 267.789 278.208C267.789 278.208 259.833 271.806 258.736 276.714C258.697 276.87 258.658 277.013 258.619 277.169C257.237 281.753 251.064 283.831 247.5 284.415C245.175 284.779 244.323 285.999 244 286.844Z",
    fill: "#1B3051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.378 210.692C305.539 210.692 266.459 218.069 259.989 226.12C256.76 230.146 256.282 276.558 256.282 276.558C256.282 276.558 260.273 281.545 268.9 278.649C268.9 278.649 275.228 246.885 274.763 237.262C274.634 234.6 301.458 236.873 306.378 235.6C311.286 234.327 323.283 223.575 320.649 218.341C318.001 213.108 306.378 210.692 306.378 210.692Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.819 162.942C311.634 162.709 314.579 161.955 317.123 161.124C320.313 160.085 322.87 158.566 321.217 155.644C319.693 152.943 317.226 146.917 317.394 141.931L311.466 146.736L307.437 149.995C307.437 149.995 307.45 151.917 307.889 155.293C307.966 155.904 308.07 156.566 308.173 157.28C308.263 157.852 308.005 158.423 307.514 158.735C307.489 158.748 307.45 158.774 307.424 158.787C305.435 160.033 306.468 163.137 308.819 162.942Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.449 149.189C307.449 149.189 307.243 149.891 307.592 152.462C311.182 151.878 314.54 148.995 314.54 148.995C312.719 148.488 312.047 146.501 310.691 146.696L307.449 149.189Z",
    fill: "#ED975D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.131 149.787C304.131 149.787 317.936 152.099 319.228 143.424C320.519 134.762 323.18 129.217 314.424 127.386C305.667 125.542 303.459 128.594 302.323 131.386C301.186 134.165 300.566 148.956 304.131 149.787Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.281 127.542C299.687 129.632 301.276 132.165 303.936 133.009C307.888 134.255 307.01 139.125 308.792 139.06C310.574 138.995 311.285 136.255 312.873 138.45C314.229 140.32 311.75 142.528 311.918 143.554C312.215 145.307 314.94 148.904 317.406 148.722C319.873 148.54 324.483 136.762 323.566 133.126C322.65 129.477 318.956 125.646 315.469 125.113C311.982 124.581 307.126 126.1 306.003 126.1C304.879 126.1 300.604 126.412 300.281 127.542Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.336 169.786C330.347 161.708 324.833 153.241 321.1 153.241C314.746 153.254 305.616 154.942 301.922 164.085C299.21 170.825 295.581 209.575 299.675 212.328C309.038 218.627 330.735 231.496 334.583 218.38C338.122 206.368 335.797 183.798 332.336 169.786Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.903 161.748C315.095 157.008 309.245 155.371 305.254 158.488C303.098 160.176 300.463 162.579 297.273 165.994C285.417 178.695 283.002 178.617 280.781 178.344C278.56 178.084 259.743 174.072 259.743 174.072C259.743 174.072 258.775 174.786 258.206 175.942C257.444 177.487 257.832 178.539 257.832 178.539C257.096 178.058 264.496 183.188 268.189 185.24C273.058 187.941 280.394 190.473 283.312 191.434C284.139 191.707 285.03 191.694 285.857 191.395C290.196 189.824 304.751 184.097 316.606 174.162C319.732 171.539 318.595 166.15 316.903 161.748Z",
    fill: "#F99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.746 153.319L320.312 150.06C320.312 150.06 307.436 151.111 305.267 158.488C305.267 158.488 315.25 153.475 321.746 153.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.999 286.545H353.09C353.813 286.532 354.381 285.935 354.304 285.246L349.448 236.535L345.212 236.912L352.173 285.883C352.25 286.272 352.599 286.558 352.999 286.545Z",
    fill: "#8CB4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.035 286.545H328.125C328.848 286.532 329.416 285.935 329.339 285.246L324.483 236.535L320.247 236.912L327.208 285.883C327.286 286.272 327.634 286.558 328.035 286.545Z",
    fill: "#8CB4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.168 286.545H281.077C280.354 286.532 279.786 285.935 279.864 285.246L284.719 236.535L288.955 236.912L281.994 285.883C281.93 286.272 281.581 286.558 281.168 286.545Z",
    fill: "#73A2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63 229.639L356.228 188.954C356.835 183.097 354.885 177.357 346.465 176.903L331.664 175.993C322.895 175.63 318.931 182.967 317.82 188.629L309.038 233.354L351.63 229.639Z",
    fill: "#8CB4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.163 237.263H283.467C282.149 237.263 281.064 236.172 281.064 234.847V231.873C281.064 230.549 282.149 229.458 283.467 229.458H351.552V234.847C351.552 236.172 350.48 237.263 349.163 237.263Z",
    fill: "#73A2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.693 237.262H310.91C309.89 237.262 309.051 236.418 309.051 235.392V231.341C309.051 230.315 309.89 229.471 310.91 229.471H351.566V235.392C351.553 236.418 350.713 237.262 349.693 237.262Z",
    fill: "#8CB4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_11418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 300,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1039_11418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 187,
    fill: "white",
    transform: "translate(27 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBox6);
export default __webpack_public_path__ + "static/media/ServiceBox6.89fd8b7843f3e3e12e6d7db39b997c1e.svg";
export { ForwardRef as ReactComponent };